import { Controller } from "@hotwired/stimulus"

// Checkbox multi-select on the Intern Tasks sheet (owner ruling 2026-09-18:
// no archive-all button, because each staffer keeps finished rows visible
// for a different length of time; instead a box on every row, tick the
// ones you are done with, one click). Lives on the page wrapper; the boxes
// sit inside rows owned by intern-task-row, so each box stops its click
// from reaching the row's open-panel handler itself. The same controller
// serves the Archived view with mode "unarchive".
export default class extends Controller {
  static targets = ["checkbox", "bar", "count", "sectionAll"]
  static values = { archiveUrl: String, unarchiveUrl: String, mode: { type: String, default: "archive" } }

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  // The header-strip box of one intern's section ticks or clears that
  // section's rows only.
  toggleSection(event) {
    const section = event.currentTarget.closest("section")
    if (!section) return
    section.querySelectorAll("[data-intern-task-bulk-target='checkbox']").forEach((box) => {
      box.checked = event.currentTarget.checked
    })
    this.update()
  }

  clear() {
    this.checkboxTargets.forEach((box) => { box.checked = false })
    this.sectionAllTargets.forEach((box) => { box.checked = false })
    this.update()
  }

  selected() {
    return this.checkboxTargets.filter((box) => box.checked)
  }

  update() {
    const n = this.selected().length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasBarTarget) this.barTarget.hidden = n === 0
    this.sectionAllTargets.forEach((all) => {
      const section = all.closest("section")
      const boxes = section ? Array.from(section.querySelectorAll("[data-intern-task-bulk-target='checkbox']")) : []
      const ticked = boxes.filter((b) => b.checked).length
      all.checked = boxes.length > 0 && ticked === boxes.length
      all.indeterminate = ticked > 0 && ticked < boxes.length
    })
  }

  async submit() {
    const ids = this.selected().map((box) => box.value)
    if (ids.length === 0 || this.submitting) return
    this.submitting = true
    const url = this.modeValue === "unarchive" ? this.unarchiveUrlValue : this.archiveUrlValue
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ task_ids: ids })
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      window.location.reload()
    } catch (err) {
      console.error("intern_task_bulk failed:", err)
      this.submitting = false
      if (window.showToast) window.showToast("error", this.modeValue === "unarchive" ? "Could not unarchive those tasks. Please try again." : "Could not archive those tasks. Please try again.")
    }
  }
}
